import { getButtonActionDefTemplates } from "./getButtonActionDefTemplates";

/**
 * Function to process the action definition of a button action. It looks for the button template based on the action name and merges the button properties,
 * overriding the default values with the ones provided in the action definition.
 * @param {Object} actionDef The action definition of the button action.
 * @param {Function} t The translation function from i18next.
 * @returns {Object} The processed action definition.
 */
export const processButtonActionDef = (actionDef, t) => {
  const buttonTemplates = getButtonActionDefTemplates(t);
  const buttonTemplate =
    buttonTemplates.find((template) => template.name === actionDef.name) ?? {};
  return {
    ...buttonTemplate,
    ...actionDef,
    buttonProps: {
      ...buttonTemplate.buttonProps,
      ...actionDef.buttonProps,
    },
  };
};
